export default __webpack_public_path__ + "static/media/paint_horse.581ac791.jpg";